export default __webpack_public_path__ + "static/media/logo.5344ca64.svg";